// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main_layout_box{display:flex;flex-direction:column;height:100%;overflow:hidden}.main_layout_box .header_box{box-sizing:border-box;height:50px;background-color:#fff;border-bottom:1px solid #dedede}.main_layout_box .content_box{position:relative;display:flex;flex:1;overflow:hidden}.main_layout_box .aside_box{box-sizing:border-box;width:70px;border-right:1px solid #dedede}.main_layout_box .router_content{position:absolute;top:0;right:0;bottom:0;left:70px;flex:1;overflow:auto}", ""]);
// Exports
module.exports = exports;
